import React from "react";
import { Skeleton } from "@mui/material";
import Marketing from "./Marketing";

export default function AuthLoading() {
  return (
    <div className="signup-layout">
      <Marketing />
      <div className="authentication">
        <div className="login-form">
          <Skeleton animation="wave" width={"100%"} />
        </div>
      </div>
    </div>
  );
}
